import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { ReportModalComponent } from '../../../../@modals/report-modal/report-modal.component';
import { FlagIconComponent } from '../../../../../@icons/flag-icon.component';
import { InfoIconComponent } from '../../../../../@icons/info-icon.component';
import { SquarePenIconComponent } from '../../../../../@icons/square-pen-icon.component';
import { DownIconComponent } from '../../../../../@icons/down-icon.component';
import { ThreeDotsIconComponent } from '../../../../../@icons/three-dots-icon.component';
import { TranslatePipe } from '@ngx-translate/core';

import { AiChatbotInfoModalComponent } from '../ai-chatbot-info-modal/ai-chatbot-info-modal.component';

/**
 * En-tête de Willy en plein écran (PC-09b) : fermer, qui parle, et un menu
 * pour « Nouvelle conversation », « Informations » et « Signaler une réponse ».
 */
@Component({
    selector: 'vw-ai-chatbot-header',
    imports: [ReportModalComponent, FlagIconComponent, InfoIconComponent, SquarePenIconComponent, DownIconComponent, ThreeDotsIconComponent, TranslatePipe, AiChatbotInfoModalComponent],
    templateUrl: './ai-chatbot-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './ai-chatbot-header.component.scss'
})
export class AiChatbotHeaderComponent {
  /** Un invité n'a ni conversation à recommencer ni réponse à signaler. */
  @Input() showMenu = true;
  /** Dernière réponse de Willy : jointe au signalement pour savoir laquelle est en cause. */
  @Input() lastAnswer: string | null = null;

  @Output() newConversation = new EventEmitter<void>();
  @Output() closeRequested = new EventEmitter<void>();

  menuOpen = false;
  showReportPopup: boolean = false;
  showInfoPopup: boolean = false;
  isReported: boolean = false;

  onCloseClick() {
    this.menuOpen = false;
    this.closeRequested.emit();
  }

  onNewConversationClick() {
    this.menuOpen = false;
    this.isReported = false;
    this.newConversation.emit();
  }

  onFlagClick() {
    this.menuOpen = false;
    this.showReportPopup = true;
  }

  /** Le signalement est parti (la feuille l'a envoyé) : l'en-tête le dit. */
  onReport() {
    this.isReported = true;
  }

  onInfoClick() {
    this.menuOpen = false;
    this.showInfoPopup = true;
  }

  onInfoModalClose() {
    this.showInfoPopup = false;
  }
}
